
















































































import RsNetworkAdvanceDialog from "@/components/dialog/rsNetworkAdvanceDialog.vue";
import RsNetworkControlDialog from "@/components/dialog/rsNetworkControlDialog.vue";
import LineChart from "@/components/chart/LineChart.vue";
import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import xlsx from "xlsx";
import { GetMetersReq, meters } from "@/api/meter";
import { RouteConfig } from "vue-router";
import { RsNetwork, ResCode, RsNetworkMeter, Meter } from "@/api/baseDefine";
import {
  GetRsNetworksReq,
  rsNetworks,
  deleteRsNetworkMeter,
  DeleteRsNetworkMeterReq,
  deleteRsNetwork,
  DeleteRsNetworkReq,
} from "@/api/rsNetwork";

/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
    LineChart,
    RsNetworkAdvanceDialog,
    RsNetworkControlDialog,
  },
})
export default class RsNetworkMeters extends Vue {
  private meterTypeUnits: string[] = ["m³", "kWh", "m³", "MWh", "kWh"];
  private listQuery: GetMetersReq = <GetMetersReq>{
    page: 1,
    pageSize: 10,
  };
  private tableDataTotal = 0;
  private listLoading = false;
  private dialogDelete = false;
  // private tableData: RsNetwork[] = [];\
  private selectRsNetworkMeters: RsNetworkMeter[] = [];
  private clicktRsNetworkMeter: RsNetworkMeter = <RsNetworkMeter>{};
  private tableData: RsNetworkMeter[] = [];
  public async getList() {
    this.tableData = [];
    this.listLoading = true;
    let req = <GetRsNetworksReq>{
      page: this.listQuery.page,
      pageSize: this.listQuery.pageSize,
      masterType: 1,
    };
    const res = await rsNetworks(req);
    if (res.code === ResCode.SUCCESS) {
      this.tableDataTotal = res.data.data.totalCount;
      for (let item of res.data.data.rsNetworks) {
        if (
          !!item.rsNetworkMeters &&
          item.rsNetworkMeters.length > 0 &&
          !!item.rsNetworkMeters[0].meter &&
          !!item.rsNetworkMeters[0].meter.meterID
        ) {
          let rsNetworkMeter: RsNetworkMeter = item.rsNetworkMeters[0];
          rsNetworkMeter.rsNetworkName = item.name;
          rsNetworkMeter.rsNetworkId = item.id;
          rsNetworkMeter.masterMeter = rsNetworkMeter.meter;
          rsNetworkMeter.baudRate = item.baudRate;
          if (rsNetworkMeter.index == 0) {
            rsNetworkMeter.hasChildren = true;
          }
          rsNetworkMeter.meter.reading = !!rsNetworkMeter.meter.reading
            ? rsNetworkMeter.meter.reading
            : 0;
          rsNetworkMeter.meter.usage = !!rsNetworkMeter.meter.usage
            ? rsNetworkMeter.meter.usage
            : 0;
          this.tableData.push(rsNetworkMeter);
        }
      }
    }
    this.listLoading = false;
  }

  public loadChild(tree, treeNode, resolve) {
    console.log("loadChild", tree, treeNode);
    let req = <GetRsNetworksReq>{
      page: 1,
      pageSize: 100,
      masterType: 2,
      rsNetwork: <RsNetwork>{
        id: tree.rsNetworkId,
      },
    };
    let masterMeter = tree.meter;
    rsNetworks(req).then((res) => {
      let rsNetworkMeters: RsNetworkMeter[] = [];
      for (let item of res.data.data.rsNetworks) {
        if (!!item.rsNetworkMeters && item.rsNetworkMeters.length > 0) {
          for (let rsNetworkMeter of item.rsNetworkMeters) {
            if (!!rsNetworkMeter.meter && !!rsNetworkMeter.meter.meterID) {
              rsNetworkMeter.masterMeter = masterMeter;
              rsNetworkMeter.rsNetworkName = item.name;
              rsNetworkMeter.rsNetworkId = item.id;
              rsNetworkMeter.baudRate = item.baudRate;
              rsNetworkMeters.push(rsNetworkMeter);
            }
          }
        }
      }
      resolve(rsNetworkMeters);
    });
  }
  private created() {
    this.getList();
  }

  public clickControl(scope) {
    this.clicktRsNetworkMeter = scope.row as RsNetworkMeter;
    console.log("clickControl", this.clicktRsNetworkMeter);
    if (this.clicktRsNetworkMeter.index == 0) {
      let rsNetworkControlRef = this.$refs.rsNetworkControlRef as any;
      rsNetworkControlRef.clickShow(this.clicktRsNetworkMeter);
    } else {
      let rsNetworkAdvanceDialogRef = this.$refs
        .rsNetworkAdvanceDialogRef as any;
      rsNetworkAdvanceDialogRef.clickShow(this.clicktRsNetworkMeter);
    }
  }

  public clickDelete(scope) {
    this.clicktRsNetworkMeter = scope.row as RsNetworkMeter;
    this.dialogDelete = true;
    console.log("clickDelete", scope);
  }

  public async deleteRsNetwork() {
    console.log("confrimDelete", this.clicktRsNetworkMeter);
    if (!!this.clicktRsNetworkMeter && this.clicktRsNetworkMeter.index > 0) {
      let req = <DeleteRsNetworkMeterReq>{
        id: this.clicktRsNetworkMeter.id,
      };
      let res = await deleteRsNetworkMeter(req);
      if (!!res && res.code == ResCode.SUCCESS) {
        this.getList();
      }
    }

    if (!!this.clicktRsNetworkMeter && this.clicktRsNetworkMeter.index == 0) {
      let req = <DeleteRsNetworkReq>{
        id: this.clicktRsNetworkMeter.rsNetworkId,
      };
      let res = await deleteRsNetwork(req);
      if (!!res && res.code == ResCode.SUCCESS) {
        this.dialogDelete = false;
        this.getList();
      }
    }
  }
  public handleSelectionChange(val) {
    this.selectRsNetworkMeters = val;
  }
}
